(function HotelProcessor($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('Hotels/processor', function onload()
		{
			var $processor = $('div.processor');
			var ajaxOptions = {};

			if ($processor.find('.agoda-processing-notice').length) {
				ajaxOptions.timeout = 35 * 60 * 1000;
			}

			HE.Ajax.get($processor.data('request'), ajaxOptions)
			.then(function processed(data) {
				console.log(data, 'processor Data');
				if (data.three_d_secure) {
					localStorage.setItem('three_d_secure', JSON.stringify(data.three_d_secure));
					window.history.back();
				} else if (data.redirect) {
					window.location.replace(data.redirect);
				}
			})
			.catch(function processorError(xhr) {
				var message = 'An error occurred while processing your booking.';

				if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
					message = xhr.responseJSON.message;
				}

				alert(message);
				window.history.back();
			});
		});
	});

}(jQuery, window.HE || {}));